import type { DripsyColor } from "@utils";
import { useDripsyColor } from "@utils";
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

function ArrowLeft({ width, height, color }: { height: number; width: number; color: DripsyColor }) {
  const finalColor = useDripsyColor({ color });
  return (
    <Svg width={width} height={height} viewBox="0 0 16 14">
      <G id="CC" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <G id="back-/-white" transform="translate(-15.000000, -16.000000)" fill={finalColor} fillRule="nonzero">
          <G id="arrow" transform="translate(15.000000, 16.000000)">
            <Path
              d="M15.0383215,5.73781947 C14.9728537,5.72719436 14.9065988,5.72229322 14.8403082,5.72315182 L3.5526213,5.72315182 L3.79875162,5.6086726 C4.03933686,5.49480155 4.25820682,5.3398253 4.44555922,5.15075571 L7.61090966,1.98540527 C8.0277929,1.58744688 8.09783987,0.947257614 7.77690453,0.468555599 C7.4033803,-0.041556652 6.68706236,-0.152315298 6.17691433,0.221208934 C6.13570181,0.251402828 6.09652845,0.284315604 6.05971623,0.319732613 L0.335755206,6.04369363 C-0.111572348,6.49052034 -0.11196587,7.21535268 0.334860837,7.66268023 C0.335147035,7.66296643 0.335469008,7.6632884 0.335755206,7.6635746 L6.05971623,13.3875356 C6.50740153,13.8339688 7.23223387,13.8329671 7.67870283,13.3852818 C7.71383364,13.3500437 7.74663909,13.3125517 7.77690453,13.2730564 C8.09783987,12.7943544 8.0277929,12.1541651 7.61090966,11.7562067 L4.45128318,8.58513233 C4.2833207,8.41699097 4.09020856,8.27600266 3.87888708,8.16728317 L3.53544942,8.01273623 L14.7773089,8.01273623 C15.3621188,8.0344515 15.8752004,7.62593956 15.9850646,7.05111077 C16.0862714,6.42702015 15.6624121,5.83906203 15.0383215,5.73781947 Z"
              id="Path"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
}
export default ArrowLeft;
